import { getCurrentUser, getCurrentUserRole } from '@/utils/auth'

function getPerms() {
  const user = getCurrentUser() || {}
  const perms = user?.perms
  if (!Array.isArray(perms)) return []
  return perms.map(p => String(p || '').trim()).filter(Boolean)
}

function isPermCode(v) {
  return typeof v === 'string' && v.trim().toLowerCase().startsWith('api:')
}

function hasRolePermission(roles) {
  const role = getCurrentUserRole()
  if (!Array.isArray(roles) || roles.length === 0) return true
  const allowed = roles.map(v => String(v).trim().toLowerCase()).filter(Boolean)
  return allowed.includes(String(role || '').trim().toLowerCase())
}

function hasApiPermission(required) {
  const perms = getPerms()
  if (perms.includes('*')) return true
  if (!required) return true
  return perms.includes(String(required).trim())
}

export default {
  mounted(el, binding) {
    const v = binding.value

    // 兼容两种用法：
    // 1) v-permission="['admin']"  旧：按角色控制
    // 2) v-permission="'api:GET:/api/orders'"  新：按后端 perm_code 控制
    // 3) v-permission="['api:GET:/x','api:POST:/y']"  新：任意一个命中即可
    let ok = true
    if (Array.isArray(v)) {
      if (v.length === 0) ok = true
      else if (v.every(isPermCode)) {
        ok = v.some(code => hasApiPermission(code))
      } else {
        ok = hasRolePermission(v)
      }
    } else if (typeof v === 'string') {
      ok = isPermCode(v) ? hasApiPermission(v) : hasRolePermission([v])
    }

    if (!ok) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}

